<template>
  <div>

    <div class="d-flex mt-2">
      <feather-icon icon="ToolIcon" size="19"/>
      <h4 class="mb-0 ml-50">
        {{ $t('MAINTENANCES_DETAILS_TITLE') }}
      </h4>
    </div>

    <b-row class="mt-2" v-if="$store.getters['maintenances.form/fields'].includes('name')">
      <b-col md="6">
        <b-form-group :label="$t('MAINTENANCES_NAME_LABEL')">
          <b-form-input 
            :disabled="$store.getters['maintenances.form/isReadOnly']"
            @input="(value)=> $store.commit('maintenances.form/updateName', {value})"
            :value="$store.getters['maintenances.form/name']"
            :placeholder="$t('MAINTENANCES_NAME_PLACEHOLDER')" 
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
          />
          <small v-if="('name' in $store.getters['maintenances.form/errors'])" class="text-danger">
            {{ $t($store.getters['maintenances.form/errors']['name'][0]) }}
          </small>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="mt-2" v-if="$store.getters['maintenances.form/fields'].includes('device_id')">
      <b-col md="6">
        <b-form-group :label="$t('MAINTENANCES_DEVICE_LABEL')">
          <v-select 
            :disabled="$store.getters['maintenances.form/isReadOnly']"
            :placeholder="$t('MAINTENANCES_DEVICE_PLACEHOLDER')" 
            @input="(value)=> $store.commit('maintenances.form/updateDeviceId', {value})"
            :value="$store.getters['maintenances.form/device_id']"
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
            :getOptionLabel="device => device.name" 
            :options="$store.getters['maintenances.form/deviceOptions']" 
            :reduce="device => device.device_id" 
          />
          <small v-if="('device_id' in $store.getters['maintenances.form/errors'])" class="text-danger">
            {{ $t($store.getters['maintenances.form/errors']['device_id'][0]) }}
          </small>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="mt-2" v-if="$store.getters['maintenances.form/fields'].includes('type')">
      <b-col md="6">
        <b-form-group :label="$t('MAINTENANCES_TYPE_LABEL')">
          <v-select 
            :disabled="$store.getters['maintenances.form/isReadOnly']"
            :placeholder="$t('MAINTENANCES_TYPE_PLACEHOLDER')" 
            @input="(value)=> $store.commit('maintenances.form/updateType', {value})"
            :value="$store.getters['maintenances.form/type']"
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
            :getOptionLabel="type => type.name" 
            :options="$store.getters['maintenances.form/typeOptions']" 
            :reduce="type => type.id"
          />
          <small v-if="('type' in $store.getters['maintenances.form/errors'])" class="text-danger">
            {{ $t($store.getters['maintenances.form/errors']['type'][0]) }}
          </small>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="mt-2" v-if="$store.getters['maintenances.form/fields'].includes('limit')">
      <b-col md="6">
        <b-form-group :label="$store.getters['maintenances.form/limitLabel']">
          <b-form-input 
            :disabled="$store.getters['maintenances.form/isReadOnly']"
            @input="(value)=> $store.commit('maintenances.form/updateLimit', {value})"
            :value="$store.getters['maintenances.form/limit']"
            :placeholder="$t('MAINTENANCES_LIMIT_PLACEHOLDER')" 
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
          />
          <small v-if="('limit' in $store.getters['maintenances.form/errors'])" class="text-danger">
            {{ $t($store.getters['maintenances.form/errors']['limit'][0]) }}
          </small>
        </b-form-group>
      </b-col>
    </b-row>
    
  </div>
</template>

<script>

import store from '@/store'

import { 
  BButton, 
  BCol, 
  BForm, 
  BFormGroup,
  BFormCheckbox,
  BFormInput, 
  BInputGroup, 
  BRow 
} from 'bootstrap-vue'

import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component'

export default {
  components: { 
    BRow, 
    BCol, 
    BFormGroup,
    BFormCheckbox,
    BFormInput, 
    BInputGroup, 
    BForm, 
    BButton, 
    vSelect,
    flatPickr
  },
  setup( props, { root }) {

    store.commit('maintenances.form/updateRoot', root)
    store.dispatch('maintenances.form/fetchOptions')

    return {}
  }
}
</script>

<style scoped>

</style>
